import { createAsyncThunk } from '@reduxjs/toolkit';
import doFetch from 'utils/api/doFetch';

import type {
  AddCurrentDevicesToOrganizationRequestBody,
  AddCurrentDevicesToOrganizationResponseType,
  OrganizationId,
} from 'redux-store/slices/organizationOverview/types';

const addCurrentDevicesToOrganizationThunk = createAsyncThunk(
  'organizationOverview/addCurrentDevicesToOrganization',
  async ({
    organizationId,
    data,
  }: {
    organizationId: OrganizationId;
    data: AddCurrentDevicesToOrganizationRequestBody;
  }): Promise<AddCurrentDevicesToOrganizationResponseType> => {
    try {
      const apiPointName = 'addCurrentDevicesToOrganzation';

      return await doFetch<typeof apiPointName>({
        apiPointName,
        body: data,
        urlParams: { organizationId },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  },
);

export default addCurrentDevicesToOrganizationThunk;
